/*
UserNavbar component
url match: / or /home
Displays overview 
*/
import { withRouter, Link } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
//import { isObjectEmpty } from '../../utils';
//import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import { withStyles } from '@material-ui/core/styles';
import { dashboardStyles } from '../../Styles/dashboardStyles';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import Fab from '@material-ui/core/Fab';
import CircularProgress from '@material-ui/core/CircularProgress';
import CustomCircularProgress from '../../Common/CustomCircularProgress';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import BarChartIcon from '@material-ui/icons/BarChart';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SettingsIcon from '@material-ui/icons/Settings';
/*const StyledDrawer = styled(Drawer)`
  & > div {
    width: 16%;
  }
`; */

const sideBarNav = [
    {
        id: 1,
        name: 'Usage Statistics',
        icon: 'stats',
        urlLink: '/statistics/usage'
    },
    {
        id: 2,
        name: 'Manage Users',
        icon: 'users',
        urlLink: '/admin/manageUsers'
    },
    {
        id: 3,
        name: 'Manage Enterprise',
        icon: 'ent',
        urlLink: '/admin/manageEnterprises'
    },
    {
        id: 4,
        name: 'Settings',
        icon: 'settings',
        urlLink: '/user/settings'
    },
    {
        id: 5,
        name: `Blocked IP's`,
        icon: 'ip',
        urlLink: '/admin/blockedIPs'
    },
    {
        id: 6,
        name: `Blocked Domains`,
        icon: 'domain',
        urlLink: '/admin/blockedDomains'
    },

]
@inject('userStore', 'documentStore', 'commonStore')
@observer
class UserNavbar extends React.Component {

    state = {
        mobileOpen: false,
        active: '',
        openUploadDialog: false
    }

    componentDidMount(){
        this.props.userStore.getServerStatus()
    }

    constructor() {
        super()
        this.inputOpenFileRef = React.createRef()
        this.zipInputFileRef = React.createRef()
    }

    handleDrawerToggle = () => {
        this.setState({
            mobileOpen: !this.state.mobileOpen
        })
    }

    openUploadDialog = () => {
        this.setState({
            openUploadDialog: true
        })
    }

    openFileModal = () => {
        this.props.documentStore.openFileAssign()
    }

    onChangeFile = event => {
        event.stopPropagation();
        event.preventDefault();
        var files = event.target.files;
        if (!files.length)
            return;
        this.props.documentStore.setUploadFiles(files);
        this.props.documentStore.uploadFiles(files[0]);
    }



    render() {
        const { classes } = this.props;
        const { user } = this.props.userStore;
        const { activeTab } = this.props.commonStore;
        const drawer = (
            <div className={classes.sidebarFlex}>

                <div>
                    <Hidden xsDown implementation="css">
                        <Link to="/">
                            <ReactSVG
                                beforeInjection={svg => {
                                    svg.classList.add(classes.svg)
                                }}
                                src={Images.logo} />
                        </Link>
                    </Hidden>
                    <div style={{ display: 'flex', paddingLeft: '2vw' }} onClick={(e) => this.props.history.push('/dashboard/drafts')}>
                        <ReactSVG
                            beforeInjection={svg => {
                                svg.classList.add(classes.sideBarIcons)
                            }}
                            src={Images[`back`]} />
                        <NavLink key='back' style={{ textDecoration: 'none', width: '100%' }} to='/dashboard/drafts' >
                            <ListItem button style={{ padding: '0px 0px 1vh 0vw', paddingLeft: '0vw !important',height: '5vh' }}>
                                <div style={{ display: 'flex', width: '100%' }}>
                                    <div style={{ color: this.props.theme.palette.white, display: 'flex', width: '100%' }} className={classes.sideBarItems}><ListItemText classes={{primary:classes.listItemText}} style={{ width: '100px' }} primary="Back" /></div>
                                </div>
                            </ListItem>
                        </NavLink>
                    </div>
                    <div>
                        <List>
                            {sideBarNav.map((item, index) => (
                                user.userType === "AGENT" && item.icon === "users" ? null :
                                    (
                                        user.userType !== 'SUPER_ADMIN' && (item.icon === 'ip' || item.icon === 'domain' || item.icon === 'ent') ? null :
                                            <NavLink key={item.id} style={{ textDecoration: 'none', color: 'inherit' }} to={item.urlLink.toLowerCase()} >
                                                <ListItem button key={item.id} style={{ padding: '0px 0px 1vh 1vw', paddingLeft: '1vw !important', height: '5vh' }}>
                                                    <div style={{ display: 'flex', paddingLeft: '1vw', width: '100%' }}>
                                                        <div>
                                                            <ReactSVG
                                                                beforeInjection={svg => {
                                                                    svg.classList.add(classes.sideBarIcons)
                                                                }}
                                                                src={item.icon.toLowerCase() === activeTab.toLowerCase() ? Images[`${item.icon}` + `Active`] : Images[`${item.icon}`]} />
                                                        </div>
                                                        <div style={{ color: item.icon.toLowerCase() === activeTab.toLowerCase() ? this.props.theme.palette.white : this.props.theme.palette.coolGray, display: 'flex', width: '100%' }} className={classes.sideBarItems}><ListItemText classes={{primary:classes.listItemText}} style={{ width: '100px' }} primary={item.name} /><ListItemText classes={{primary:classes.listItemText}} primary="" /></div>
                                                    </div>
                                                </ListItem>
                                            </NavLink>
                                    )
                            ))}
                        </List>
                    </div>
                </div>
                <div className={classes.sidebarFooter} style={{ height: '6vh' }} >
                    <div className={classes.trademark}>
                        © Amygb 2020
                    </div>
                </div>
            </div>

        );
        const { mobileOpen } = this.state;
        return (
            <div className={classes.sidebarContainer}>
                <CssBaseline />
                <Hidden smUp implementation="css">
                    <AppBar position="fixed" className={classes.appBar}>
                        <Toolbar>
                            <IconButton
                                aria-label="mobileOpen drawer"
                                edge="start"
                                onClick={this.handleDrawerToggle}
                                className={classes.menuButton}
                            >
                                <MenuIcon className={classes.menuIcon} />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                </Hidden>
                <nav className={classes.drawer} aria-label="navigation bar">
                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Hidden smUp implementation="css">
                        <Drawer
                            variant="temporary"
                            open={mobileOpen}
                            onClose={this.handleDrawerToggle}
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                            ModalProps={{
                                keepMounted: true, // Better mobileOpen performance on mobile.
                            }}
                        >
                            <IconButton onClick={this.handleDrawerToggle} className={classes.closeMenuButton}>
                                <ReactSVG src={Images.logo} />
                            </IconButton>
                            {drawer}
                        </Drawer>
                    </Hidden>
                    <Hidden xsDown implementation="css">
                        <Drawer
                            className={classes.drawer}
                            variant="permanent"
                            anchor="left"
                            docked={classes.drawerPaper}
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                        >
                            {drawer}
                        </Drawer>
                    </Hidden>
                </nav>
            </div>
        );
    }
}

export default withStyles(dashboardStyles, { withTheme: true })(withRouter(UserNavbar));
